module.exports = __webpack_public_path__ + "static/img/sc_1209.07bc505.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc_1209.png
// module id = PBja
// module chunks = 1